import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';


export class GetRsvpQuestionsErrorAction implements Action {
  public static readonly type = 'GetRsvpQuestionsErrorAction';

  constructor(public error: BijbError) {
  }

  public type = GetRsvpQuestionsErrorAction.type;
}
